import { activityItemService } from "@/services/activityItemService";
import { ProductItemsSection } from "@/components/common";
import type { ServiceCategory } from "@/types";

interface MenuItemsSectionProps {
  activityId: string;
  activityCommissionRate: number;
  serviceCategories: ServiceCategory[];
}

export function MenuItemsSection({
  activityId,
  activityCommissionRate,
  serviceCategories,
}: MenuItemsSectionProps) {
  return (
    <ProductItemsSection
      activityId={activityId}
      activityCommissionRate={activityCommissionRate}
      itemType="menu"
      entityType="activity_items"
      queryKey="menuItems"
      getAllFn={(id) => activityItemService.listMenu(id)}
      createFn={activityItemService.create}
      updateFn={activityItemService.update}
      deleteFn={activityItemService.delete}
      serviceCategories={serviceCategories}
    />
  );
}
